const appendCurrentQueryParams = (href, options = {}) => {
  const currentSearch = options.currentSearch ?? window?.location?.search;

  if (!currentSearch) {
    return href;
  }

  try {
    const baseOrigin = options.baseOrigin ?? window?.location?.origin;
    const url = new URL(href, baseOrigin);
    const currentParams = new URLSearchParams(currentSearch);
    const targetParams = new URLSearchParams(url.search);
    const ignoredKeys = new Set(['date', 'seats']);

    currentParams.forEach((value, key) => {
      if (ignoredKeys.has(key)) {
        return;
      }
      if (!targetParams.has(key)) {
        targetParams.append(key, value);
      }
    });

    const mergedSearch = targetParams.toString();
    url.search = mergedSearch ? `?${mergedSearch}` : '';

    return href.startsWith('/')
      ? `${url.pathname}${url.search}${url.hash}`
      : url.toString();
  } catch (error) {
    return href;
  }
};

export default appendCurrentQueryParams;
